import * as React from "react"
import { SVGProps } from "react"
const OrganizationsAnimated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="animated"
    id="freepik_stories-hospital-building"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 750 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
    width={250}
    height={250}
  >
    <style>
      {
        "svg#freepik_stories-hospital-building:not(.animated) .animable {opacity: 0;}svg#freepik_stories-hospital-building.animated #freepik--hospital-building--inject-47 {animation: 2.6s 1 forwards ease-in slideUp;animation-delay: 0s;}svg#freepik_stories-hospital-building.animated #freepik--Ambulance--inject-47 {animation: 1.5s Infinite  linear wind;animation-delay: 0s;}            @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }"
      }
    </style>
    <g
      id="freepik--background-complete--inject-47"
      style={{
        transformOrigin: "374.984px 273.588px 0px",
      }}
      className="animable animator-active"
    >
      <path
        d="M398.87,141.47c5.54,0,143.92-1,183-1,2.73,0-.72-4.73-2.23-5.06-4.81-1-9.81-1.11-14.7-1.61a48.31,48.31,0,0,1-14-3.51c-3.85-1.63-7.69-3.51-11.85-4.15-8.05-1.27-15.12,3.1-22.67,5a17.11,17.11,0,0,1-13.73-1.87c-3.49-2.1-6.67-4.61-10.32-6.46a56.59,56.59,0,0,0-45.22-2.07,53.32,53.32,0,0,0-9.89,5.06c-3.69,2.42-6.87,5.52-10.57,7.91-8.2,5.3-18.33,3.58-27.27,6.62C398.94,140.55,398.39,141.47,398.87,141.47Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "490.787px 129.234px 0px",
        }}
        id="elci28ivj3pym"
        className="animable"
      />
      <path
        d="M554.82,213.25c7.33,0,130.71.81,138.46.56a.6.6,0,0,0,.3-1.11c-4.89-2.42-10.43-1.93-15.51-3.64-3-1-4.82-3-6.9-5.2a14.32,14.32,0,0,0-6.42-4.2,13.58,13.58,0,0,0-7-.21c-2.5.59-4.67,2-7.06,2.93-5.93,2.24-11.69.11-15.92-4.28-3.49-3.61-6.92-7-11.67-9a15.47,15.47,0,0,0-12.35-.17c-4.53,2-7.63,6.18-11.89,8.65-5,2.95-11.06,2.25-16.63,3.14s-9.83,5.58-14.71,8.28a10.46,10.46,0,0,1-5.33,1.64,32.35,32.35,0,0,1-3.24-.45c-1.68-.21-3.27-.16-4.4,1.24C554.28,211.8,554.34,213.25,554.82,213.25Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "624.127px 200.793px 0px",
        }}
        id="elnu04dytxyl"
        className="animable"
      />
      <path
        d="M56.44,221.21c5.35,0,95.42.59,101.08.41.41,0,.63-.61.22-.81-3.56-1.77-7.61-1.41-11.32-2.66-2.18-.74-3.52-2.16-5-3.8a10.35,10.35,0,0,0-4.68-3.06,10,10,0,0,0-5.11-.16c-1.82.44-3.41,1.48-5.15,2.14-4.33,1.64-8.54.08-11.63-3.12-2.54-2.64-5-5.13-8.51-6.55a11.3,11.3,0,0,0-9-.12C94,205,91.7,208,88.6,209.79c-3.68,2.15-8.08,1.65-12.14,2.29s-7.19,4.07-10.75,6a7.61,7.61,0,0,1-3.88,1.21,23.72,23.72,0,0,1-2.37-.34c-1.23-.15-2.39-.11-3.22.91C56,220.15,56.08,221.21,56.44,221.21Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "107.031px 212.129px 0px",
        }}
        id="el39fihehmsi6"
        className="animable"
      />
      <path
        d="M528,110.37c5.35,0,95.43.59,101.09.41.4,0,.62-.61.22-.81-3.57-1.77-7.62-1.41-11.33-2.66-2.18-.74-3.52-2.17-5-3.8a10.43,10.43,0,0,0-4.69-3.06,9.81,9.81,0,0,0-5.1-.16c-1.83.43-3.42,1.48-5.16,2.14-4.33,1.63-8.53.08-11.62-3.12-2.55-2.64-5.06-5.13-8.52-6.55a11.32,11.32,0,0,0-9-.13c-3.31,1.5-5.58,4.51-8.68,6.32-3.68,2.15-8.08,1.64-12.14,2.29s-7.18,4.07-10.75,6a7.58,7.58,0,0,1-3.88,1.21,23.72,23.72,0,0,1-2.37-.34,3.24,3.24,0,0,0-3.21.91C527.63,109.31,527.67,110.37,528,110.37Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "578.618px 101.288px 0px",
        }}
        id="ela2v8m6btzuw"
        className="animable"
      />
      <path
        d="M134.91,110.74c.11.3,142,0,140.18,0-.81,0,1.24-1.22.44-1.61-4.62-2.3-9.67-2.36-14.7-2.82a22.64,22.64,0,0,1-8.58-2.09c-2.68-1.4-4.35-3.83-6.24-6.07A26.68,26.68,0,0,0,221.78,89c-10.09,1.58-18,9.26-28.14,10.68-6.07.85-11.81-1.5-17.74-2.33a21.67,21.67,0,0,0-13.33,2.44c-3.2,1.58-6.15,2.92-9.77,3.17-2.78.2-5.57-.12-8.35-.15a18.71,18.71,0,0,0-12.29,4.91C131.71,108.09,130.28,110.74,134.91,110.74Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "203.657px 99.7951px 0px",
        }}
        id="elljrh1tsq34"
        className="animable"
      />
      <g id="elaw71ld70vac">
        <rect
          x={88.99}
          y={278.7}
          width={34.29}
          height={179.75}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "106.135px 368.575px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el98n76bprfyb">
        <rect
          x={111.29}
          y={284.54}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 287.97px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eleatinj6nbpp">
        <rect
          x={102.76}
          y={284.54}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 287.97px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elnzxb4swv09">
        <rect
          x={111.29}
          y={296.2}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 299.63px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eln8la79r29x">
        <rect
          x={102.76}
          y={296.2}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 299.63px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="ela0sctt19mz8">
        <rect
          x={111.29}
          y={307.85}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 311.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="els8f4q0aesbp">
        <rect
          x={102.76}
          y={307.85}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 311.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el8gkq2u2s4ev">
        <rect
          x={111.29}
          y={319.5}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 322.93px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0o3p2lex29hi">
        <rect
          x={102.76}
          y={319.5}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 322.93px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eld97jgl9gfzu">
        <rect
          x={111.29}
          y={331.15}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 334.58px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el4t8vxv98w">
        <rect
          x={102.76}
          y={331.15}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 334.58px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elb5j44wfdurw">
        <rect
          x={111.29}
          y={342.81}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 346.24px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elog7lts8u628">
        <rect
          x={102.76}
          y={342.81}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 346.24px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0rel6e8yg0xi">
        <rect
          x={111.29}
          y={354.46}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 357.89px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eledgsx86x9v7">
        <rect
          x={102.76}
          y={354.46}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 357.89px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el16pg1vbnklg">
        <rect
          x={111.29}
          y={366.11}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 369.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elxf8a5qfzjq">
        <rect
          x={102.76}
          y={366.11}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 369.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el4u2pryuynqd">
        <rect
          x={111.29}
          y={377.76}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 381.19px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="ellb4wax2dpf">
        <rect
          x={102.76}
          y={377.76}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 381.19px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el4pv5093kmas">
        <rect
          x={111.29}
          y={389.42}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 392.85px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elqt2qyjd4q8m">
        <rect
          x={102.76}
          y={389.42}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 392.85px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el14srvcio157">
        <rect
          x={111.29}
          y={401.07}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 404.5px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elpv5215qb8ug">
        <rect
          x={102.76}
          y={401.07}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 404.5px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elgzhnrn5tqje">
        <rect
          x={111.29}
          y={412.72}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 416.15px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elwf9jab6kol8">
        <rect
          x={102.76}
          y={412.72}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 416.15px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elvzryqn8xtcb">
        <rect
          x={111.29}
          y={424.38}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 427.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el67o4tgw9ejx">
        <rect
          x={102.76}
          y={424.38}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 427.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elfk07ona9lk">
        <rect
          x={111.29}
          y={436.03}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "114.625px 439.46px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={94.31}
        y={436.03}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 439.46px 0px",
        }}
        id="elvwwjw0yud4"
        className="animable"
      />
      <rect
        x={94.31}
        y={424.38}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 427.81px 0px",
        }}
        id="elznfep332wa"
        className="animable"
      />
      <rect
        x={94.31}
        y={412.72}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 416.15px 0px",
        }}
        id="elktrhk0zs6za"
        className="animable"
      />
      <rect
        x={94.31}
        y={401.07}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 404.5px 0px",
        }}
        id="el5tdetsrhywm"
        className="animable"
      />
      <rect
        x={94.31}
        y={389.42}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 392.85px 0px",
        }}
        id="elo3pa4xfcmzc"
        className="animable"
      />
      <rect
        x={94.31}
        y={377.76}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 381.19px 0px",
        }}
        id="elx3zzizfbld"
        className="animable"
      />
      <rect
        x={94.31}
        y={366.11}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 369.54px 0px",
        }}
        id="el5pfc4umby2"
        className="animable"
      />
      <rect
        x={94.31}
        y={354.46}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 357.89px 0px",
        }}
        id="elxxyf9r7w8"
        className="animable"
      />
      <rect
        x={94.31}
        y={342.81}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 346.24px 0px",
        }}
        id="el03r0v76mmdj7"
        className="animable"
      />
      <rect
        x={94.31}
        y={331.15}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 334.58px 0px",
        }}
        id="eljyn70paijgq"
        className="animable"
      />
      <rect
        x={94.31}
        y={319.5}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 322.93px 0px",
        }}
        id="elgvmaf8fi4b6"
        className="animable"
      />
      <rect
        x={94.31}
        y={307.85}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 311.28px 0px",
        }}
        id="el2fugvmtatga"
        className="animable"
      />
      <rect
        x={94.31}
        y={296.2}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 299.63px 0px",
        }}
        id="elcv251cndqr"
        className="animable"
      />
      <rect
        x={94.31}
        y={284.54}
        width={6.67}
        height={6.86}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "97.645px 287.97px 0px",
        }}
        id="elnamad5zufb"
        className="animable"
      />
      <g id="elmo5t7pz3px">
        <rect
          x={102.76}
          y={436.03}
          width={6.67}
          height={6.86}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "106.095px 439.46px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elbluolf0d6gs">
        <rect
          x={61.95}
          y={278.7}
          width={27.04}
          height={179.75}
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "75.47px 368.575px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={64.74}
        y={436.03}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 439.46px 0px",
        }}
        id="elzh9nwck4qrn"
        className="animable"
      />
      <rect
        x={71.78}
        y={436.03}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 439.46px 0px",
        }}
        id="elm0azd3sc71"
        className="animable"
      />
      <rect
        x={64.74}
        y={424.38}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 427.81px 0px",
        }}
        id="el81bkpb018ut"
        className="animable"
      />
      <rect
        x={71.78}
        y={424.38}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 427.81px 0px",
        }}
        id="el8ovu6zexw73"
        className="animable"
      />
      <rect
        x={64.74}
        y={412.72}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 416.15px 0px",
        }}
        id="el1fx1c5fkpop"
        className="animable"
      />
      <rect
        x={71.78}
        y={412.72}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 416.15px 0px",
        }}
        id="el2jini7g0cp2"
        className="animable"
      />
      <rect
        x={64.74}
        y={401.07}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 404.5px 0px",
        }}
        id="ela8ezo92mif9"
        className="animable"
      />
      <rect
        x={71.78}
        y={401.07}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 404.5px 0px",
        }}
        id="elm21pbethcf"
        className="animable"
      />
      <rect
        x={64.74}
        y={389.42}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 392.85px 0px",
        }}
        id="eljxiktjt1wtd"
        className="animable"
      />
      <rect
        x={71.78}
        y={389.42}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 392.85px 0px",
        }}
        id="elwnpyw209xwf"
        className="animable"
      />
      <rect
        x={64.74}
        y={377.76}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 381.19px 0px",
        }}
        id="eldxfjxj5zv"
        className="animable"
      />
      <rect
        x={71.78}
        y={377.76}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 381.19px 0px",
        }}
        id="elyn7c3538l2"
        className="animable"
      />
      <rect
        x={64.74}
        y={366.11}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 369.54px 0px",
        }}
        id="elonnqpg2ocj"
        className="animable"
      />
      <rect
        x={71.78}
        y={366.11}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 369.54px 0px",
        }}
        id="el1ppbypx715m"
        className="animable"
      />
      <rect
        x={64.74}
        y={354.46}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 357.89px 0px",
        }}
        id="elbqpe913rrjk"
        className="animable"
      />
      <rect
        x={71.78}
        y={354.46}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 357.89px 0px",
        }}
        id="el5xteso1e7x"
        className="animable"
      />
      <rect
        x={64.74}
        y={342.81}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 346.24px 0px",
        }}
        id="el6nmp5jllwf5"
        className="animable"
      />
      <rect
        x={71.78}
        y={342.81}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 346.24px 0px",
        }}
        id="elro91bs9c7sk"
        className="animable"
      />
      <rect
        x={64.74}
        y={331.15}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 334.58px 0px",
        }}
        id="el8iuya5i79nj"
        className="animable"
      />
      <rect
        x={71.78}
        y={331.15}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 334.58px 0px",
        }}
        id="el247pn1wce5u"
        className="animable"
      />
      <rect
        x={64.74}
        y={319.5}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 322.93px 0px",
        }}
        id="el0v4mxdvhkdgh"
        className="animable"
      />
      <rect
        x={71.78}
        y={319.5}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 322.93px 0px",
        }}
        id="els3qmxuxnkq"
        className="animable"
      />
      <rect
        x={64.74}
        y={307.85}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 311.28px 0px",
        }}
        id="el5hy8eaf97p4"
        className="animable"
      />
      <rect
        x={71.78}
        y={307.85}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 311.28px 0px",
        }}
        id="el4z85n3t69u3"
        className="animable"
      />
      <rect
        x={64.74}
        y={296.2}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 299.63px 0px",
        }}
        id="el1mkaue9q6umj"
        className="animable"
      />
      <rect
        x={71.78}
        y={296.2}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 299.63px 0px",
        }}
        id="elq1vj8ytnki"
        className="animable"
      />
      <rect
        x={64.74}
        y={284.54}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "67.49px 287.97px 0px",
        }}
        id="elws407bn3lf"
        className="animable"
      />
      <g id="eld8jzzm5pgh5">
        <rect
          x={78.76}
          y={284.54}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 287.97px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elg6ovbbgl08r">
        <rect
          x={78.76}
          y={296.2}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 299.63px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el8ml5hne6ml4">
        <rect
          x={78.76}
          y={307.85}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 311.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elecf2zlcox25">
        <rect
          x={78.76}
          y={319.5}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 322.93px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elm72lyj1tsn">
        <rect
          x={78.76}
          y={331.15}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 334.58px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eluwd5hq7359">
        <rect
          x={78.76}
          y={342.81}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 346.24px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elbpsx13ghowq">
        <rect
          x={78.76}
          y={354.46}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 357.89px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elx2uqfw1z16q">
        <rect
          x={78.76}
          y={366.11}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 369.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elddkk51cst3s">
        <rect
          x={78.76}
          y={377.76}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 381.19px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el08pedgku6vja">
        <rect
          x={78.76}
          y={389.42}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 392.85px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elkqyb3m7nva">
        <rect
          x={78.76}
          y={401.07}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 404.5px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elq8vlk6f7rj">
        <rect
          x={78.76}
          y={412.72}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 416.15px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elff8q0fqokeg">
        <rect
          x={78.76}
          y={424.38}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 427.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eloc6ubjukfwf">
        <rect
          x={78.76}
          y={436.03}
          width={5.5}
          height={6.86}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "81.51px 439.46px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={71.78}
        y={284.54}
        width={5.5}
        height={6.86}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "74.53px 287.97px 0px",
        }}
        id="el8syft5rixwl"
        className="animable"
      />
      <rect
        x={651.42}
        y={274.78}
        width={35.77}
        height={183.67}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "669.305px 366.615px 0px",
        }}
        id="elpsjpwfnt6jl"
        className="animable"
      />
      <g id="el0etx230owzff">
        <rect
          x={651.42}
          y={271.12}
          width={36.63}
          height={3.66}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "669.735px 272.95px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={680.33}
        y={280.17}
        width={3.62}
        height={178.28}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "682.14px 369.31px 0px",
        }}
        id="el7mp07efuxec"
        className="animable"
      />
      <rect
        x={673.91}
        y={280.17}
        width={3.62}
        height={178.28}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "675.72px 369.31px 0px",
        }}
        id="el645bonak45"
        className="animable"
      />
      <rect
        x={667.49}
        y={280.17}
        width={3.62}
        height={178.28}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "669.3px 369.31px 0px",
        }}
        id="elhzk4hthzqwq"
        className="animable"
      />
      <rect
        x={661.07}
        y={280.17}
        width={3.62}
        height={178.28}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "662.88px 369.31px 0px",
        }}
        id="elwizwbgujw5r"
        className="animable"
      />
      <rect
        x={654.65}
        y={280.17}
        width={3.62}
        height={178.28}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "656.46px 369.31px 0px",
        }}
        id="el3rvvws8u4jf"
        className="animable"
      />
      <g id="el02egkfdcpwhp">
        <rect
          x={680.33}
          y={284.79}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 288.4px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elhkqzb2ipvcv">
        <rect
          x={673.91}
          y={284.79}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 288.4px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el7vgpnk4ry6w">
        <rect
          x={667.49}
          y={284.79}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 288.4px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elqa3zwwus8qr">
        <rect
          x={661.07}
          y={284.79}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 288.4px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elwusyoalo73f">
        <rect
          x={654.65}
          y={284.79}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 288.4px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elh75zmawm9j8">
        <rect
          x={680.33}
          y={296.53}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 300.14px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elw45x9ssrj1g">
        <rect
          x={673.91}
          y={296.53}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 300.14px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1v6c6fy856wh">
        <rect
          x={667.49}
          y={296.53}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 300.14px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1nytaf4hjp7">
        <rect
          x={661.07}
          y={296.53}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 300.14px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elxjlgs4h4qpr">
        <rect
          x={654.65}
          y={296.53}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 300.14px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eljvuv48husvj">
        <rect
          x={680.33}
          y={308.26}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 311.87px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elpigxrqlydvm">
        <rect
          x={673.91}
          y={308.26}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 311.87px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elsmvxve6tntd">
        <rect
          x={667.49}
          y={308.26}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 311.87px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el7x4mhtfellj">
        <rect
          x={661.07}
          y={308.26}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 311.87px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elgofanneadcj">
        <rect
          x={654.65}
          y={308.26}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 311.87px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elsntaj86qs2">
        <rect
          x={680.33}
          y={320}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 323.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elbc1akg6asi">
        <rect
          x={673.91}
          y={320}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 323.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el4jorma3oqme">
        <rect
          x={667.49}
          y={320}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 323.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elem0wmhrfexc">
        <rect
          x={661.07}
          y={320}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 323.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el12vhaux6upmd">
        <rect
          x={654.65}
          y={320}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 323.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el33pmfo4ilpu">
        <rect
          x={680.33}
          y={331.73}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 335.34px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elo4ihx34rb1n">
        <rect
          x={673.91}
          y={331.73}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 335.34px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elv15sbjo2vxe">
        <rect
          x={667.49}
          y={331.73}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 335.34px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el99ryzhu19m7">
        <rect
          x={661.07}
          y={331.73}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 335.34px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el7zmninlx3hu">
        <rect
          x={654.65}
          y={331.73}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 335.34px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eljc19q2esdvd">
        <rect
          x={680.33}
          y={343.47}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 347.08px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eloaxqlv5r37g">
        <rect
          x={673.91}
          y={343.47}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 347.08px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elkw5ebqkrths">
        <rect
          x={667.49}
          y={343.47}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 347.08px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el7f24egf7y0u">
        <rect
          x={661.07}
          y={343.47}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 347.08px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elouaeqbbl1j">
        <rect
          x={654.65}
          y={343.47}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 347.08px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elasety743gd">
        <rect
          x={680.33}
          y={355.2}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 358.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el87r1fapw137">
        <rect
          x={673.91}
          y={355.2}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 358.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elx9kvz8k4gy8">
        <rect
          x={667.49}
          y={355.2}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 358.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el7hkriegz3bf">
        <rect
          x={661.07}
          y={355.2}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 358.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elm08ne5e2w6">
        <rect
          x={654.65}
          y={355.2}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 358.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elujeaippfgfr">
        <rect
          x={680.33}
          y={366.93}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 370.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elz4smu5o0fpg">
        <rect
          x={673.91}
          y={366.93}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 370.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elmns7t1vc90q">
        <rect
          x={667.49}
          y={366.93}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 370.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eleubewhykxi4">
        <rect
          x={661.07}
          y={366.93}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 370.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0uzbrbaohr39">
        <rect
          x={654.65}
          y={366.93}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 370.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0b4a1zf8af3">
        <rect
          x={680.33}
          y={378.67}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 382.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elme8q71oqp7i">
        <rect
          x={673.91}
          y={378.67}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 382.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eldrni4hcvipe">
        <rect
          x={667.49}
          y={378.67}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 382.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elbtso5ok0o">
        <rect
          x={661.07}
          y={378.67}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 382.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elnuw2ouuu6zf">
        <rect
          x={654.65}
          y={378.67}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 382.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el3bwxc2jl40x">
        <rect
          x={680.33}
          y={390.4}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 394.01px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elju21ovisjgm">
        <rect
          x={673.91}
          y={390.4}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 394.01px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elowaf3m6hc1h">
        <rect
          x={667.49}
          y={390.4}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 394.01px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elsyfhavqk38r">
        <rect
          x={661.07}
          y={390.4}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 394.01px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0dvg08fdyjd7">
        <rect
          x={654.65}
          y={390.4}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 394.01px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elg0dhvjezym">
        <rect
          x={680.33}
          y={402.14}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 405.75px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1x2fofpg7p2">
        <rect
          x={673.91}
          y={402.14}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 405.75px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elqu17nbc2yai">
        <rect
          x={667.49}
          y={402.14}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 405.75px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el2wwc6lwwjtw">
        <rect
          x={661.07}
          y={402.14}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 405.75px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el6dyiuka6y4f">
        <rect
          x={654.65}
          y={402.14}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 405.75px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elcg5pbxay5qo">
        <rect
          x={680.33}
          y={413.87}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 417.48px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="ellpv7agmdky">
        <rect
          x={673.91}
          y={413.87}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 417.48px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elzvz36xf1yj8">
        <rect
          x={667.49}
          y={413.87}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 417.48px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elb8eycie2j8k">
        <rect
          x={661.07}
          y={413.87}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 417.48px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elwyn7xudik0r">
        <rect
          x={654.65}
          y={413.87}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 417.48px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elmf07gk7ikb">
        <rect
          x={680.33}
          y={425.6}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "682.14px 429.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elrlk2z071x3b">
        <rect
          x={673.91}
          y={425.6}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "675.72px 429.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elg600wjqya1">
        <rect
          x={667.49}
          y={425.6}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "669.3px 429.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elhnq36hbcag">
        <rect
          x={661.07}
          y={425.6}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "662.88px 429.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el5nw1uns97et">
        <rect
          x={654.65}
          y={425.6}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "656.46px 429.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={680.33}
        y={437.34}
        width={3.62}
        height={21.12}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "682.14px 447.9px 0px",
        }}
        id="el8wrl1wdqln5"
        className="animable"
      />
      <rect
        x={673.91}
        y={437.34}
        width={3.62}
        height={21.12}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "675.72px 447.9px 0px",
        }}
        id="elzidshc81zpm"
        className="animable"
      />
      <rect
        x={667.49}
        y={437.34}
        width={3.62}
        height={21.12}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "669.3px 447.9px 0px",
        }}
        id="elu7rwpgb33f"
        className="animable"
      />
      <rect
        x={661.07}
        y={437.34}
        width={3.62}
        height={21.12}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "662.88px 447.9px 0px",
        }}
        id="elzvie66z5nff"
        className="animable"
      />
      <rect
        x={654.65}
        y={437.34}
        width={3.62}
        height={21.12}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "656.46px 447.9px 0px",
        }}
        id="els963m5ocx4"
        className="animable"
      />
      <rect
        x={628.45}
        y={274.78}
        width={22.97}
        height={183.67}
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "639.935px 366.615px 0px",
        }}
        id="ellzwzms9vv4"
        className="animable"
      />
      <g id="elrqf8u2rg2bk">
        <rect
          x={627.46}
          y={271.12}
          width={23.96}
          height={3.66}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "639.44px 272.95px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={644.56}
        y={280.17}
        width={3.62}
        height={178.28}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "646.37px 369.31px 0px",
        }}
        id="eled7b2uo6dae"
        className="animable"
      />
      <rect
        x={638.14}
        y={280.17}
        width={3.62}
        height={178.28}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "639.95px 369.31px 0px",
        }}
        id="elt4ah1zmhlpg"
        className="animable"
      />
      <rect
        x={631.72}
        y={280.17}
        width={3.62}
        height={178.28}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "633.53px 369.31px 0px",
        }}
        id="elk6klivsq4o9"
        className="animable"
      />
      <g id="el6xct3815j7s">
        <rect
          x={644.56}
          y={284.79}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 288.4px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elw40qqkmg0c">
        <rect
          x={638.14}
          y={284.79}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 288.4px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elou8m7rpdjx">
        <rect
          x={631.72}
          y={284.79}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 288.4px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eljwr5cxwokyd">
        <rect
          x={644.56}
          y={296.53}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 300.14px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="ele1obhht3xt">
        <rect
          x={638.14}
          y={296.53}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 300.14px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elbmlve7fcume">
        <rect
          x={631.72}
          y={296.53}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 300.14px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elstd91jgxypr">
        <rect
          x={644.56}
          y={308.26}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 311.87px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elyccv8oj3ohb">
        <rect
          x={638.14}
          y={308.26}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 311.87px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elqw9p4i2j9fe">
        <rect
          x={631.72}
          y={308.26}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 311.87px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el5zvqlzhmgkv">
        <rect
          x={644.56}
          y={320}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 323.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el7mzleu4ngfb">
        <rect
          x={638.14}
          y={320}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 323.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elaq0i4e95xfs">
        <rect
          x={631.72}
          y={320}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 323.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eluv49u8oizxr">
        <rect
          x={644.56}
          y={331.73}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 335.34px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elxvufsm9phlr">
        <rect
          x={638.14}
          y={331.73}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 335.34px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eliteag4kbf9">
        <rect
          x={631.72}
          y={331.73}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 335.34px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0mbtzdb7ss8f">
        <rect
          x={644.56}
          y={343.47}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 347.08px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el4wz1l0x8p7s">
        <rect
          x={638.14}
          y={343.47}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 347.08px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elq02wmudn64h">
        <rect
          x={631.72}
          y={343.47}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 347.08px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elsg1319zn4j7">
        <rect
          x={644.56}
          y={355.2}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 358.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eldrs3ycnhzcf">
        <rect
          x={638.14}
          y={355.2}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 358.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elxnpnj4dains">
        <rect
          x={631.72}
          y={355.2}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 358.81px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eldkrq7pp3n9i">
        <rect
          x={644.56}
          y={366.93}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 370.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0j2x1n2hnve5">
        <rect
          x={638.14}
          y={366.93}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 370.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eluab1i14fk19">
        <rect
          x={631.72}
          y={366.93}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 370.54px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el3kwylxekz3j">
        <rect
          x={644.56}
          y={378.67}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 382.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el3wq5yd6uum5">
        <rect
          x={638.14}
          y={378.67}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 382.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elux67y6qb3nn">
        <rect
          x={631.72}
          y={378.67}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 382.28px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elhup5tzckfab">
        <rect
          x={644.56}
          y={390.4}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 394.01px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elnzwpxbwyc6n">
        <rect
          x={638.14}
          y={390.4}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 394.01px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el4p9leturtpd">
        <rect
          x={631.72}
          y={390.4}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 394.01px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el2x7ivmglqwe">
        <rect
          x={644.56}
          y={402.14}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 405.75px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eldd6yof2kwkq">
        <rect
          x={638.14}
          y={402.14}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 405.75px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elkveytqgxvb">
        <rect
          x={631.72}
          y={402.14}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 405.75px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elpmgaojbd45i">
        <rect
          x={644.56}
          y={413.87}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 417.48px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="els2vabpt69u">
        <rect
          x={638.14}
          y={413.87}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 417.48px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eluhvjiytuqs">
        <rect
          x={631.72}
          y={413.87}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 417.48px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elrn653xv978c">
        <rect
          x={644.56}
          y={425.6}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "646.37px 429.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elrsr6t7w44n">
        <rect
          x={638.14}
          y={425.6}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "639.95px 429.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elc21ypz0241t">
        <rect
          x={631.72}
          y={425.6}
          width={3.62}
          height={7.22}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "633.53px 429.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={644.56}
        y={437.34}
        width={3.62}
        height={21.12}
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "646.37px 447.9px 0px",
        }}
        id="elglxrgim9qyf"
        className="animable"
      />
      <rect
        x={638.14}
        y={437.34}
        width={3.62}
        height={21.12}
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "639.95px 447.9px 0px",
        }}
        id="elw2jbyih7ak"
        className="animable"
      />
      <rect
        x={631.72}
        y={437.34}
        width={3.62}
        height={21.12}
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "633.53px 447.9px 0px",
        }}
        id="elhoowc7zob0q"
        className="animable"
      />
      <g id="elwnkfbo4zna">
        <rect
          x={102.66}
          y={331.96}
          width={18.12}
          height={21.4}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "111.72px 342.66px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el21mztczjbxq">
        <rect
          x={91.17}
          y={331.96}
          width={11.49}
          height={22.19}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "96.915px 343.055px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elyv4adgh0j1i">
        <rect
          x={90.41}
          y={341.41}
          width={11.4}
          height={12.74}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "96.11px 347.78px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1ervz02utfk">
        <rect
          x={83.3}
          y={341.41}
          width={7.11}
          height={12.74}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "86.855px 347.78px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elgpiziipc9v7">
        <rect
          x={98.43}
          y={351.97}
          width={29.3}
          height={106.48}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "113.08px 405.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elntotchux4pk">
        <rect
          x={115.17}
          y={356.55}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 358.43px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elisdrkkn492">
        <rect
          x={103.38}
          y={356.55}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 358.43px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eloofp2f4djc">
        <rect
          x={115.17}
          y={362.94}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 364.82px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elma08fgegnpn">
        <rect
          x={103.38}
          y={362.94}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 364.82px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el3tk0vzxzirj">
        <rect
          x={115.17}
          y={369.33}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 371.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el6kodjfar5y3">
        <rect
          x={103.38}
          y={369.33}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 371.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el8fm9z0kjssk">
        <rect
          x={115.17}
          y={375.73}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 377.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elgdegyy8ppc6">
        <rect
          x={103.38}
          y={375.73}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 377.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1qfhj8hxe3j">
        <rect
          x={115.17}
          y={382.12}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 384px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elgyreimq2tpi">
        <rect
          x={103.38}
          y={382.12}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 384px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elyv8ugzaeum">
        <rect
          x={115.17}
          y={388.51}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 390.39px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elqumgabe9dgf">
        <rect
          x={103.38}
          y={388.51}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 390.39px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el2j6kmc0wkj8">
        <rect
          x={115.17}
          y={394.9}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 396.78px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eljg2tdk4aabe">
        <rect
          x={103.38}
          y={394.9}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 396.78px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eln146tgjvhjg">
        <rect
          x={115.17}
          y={401.29}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 403.17px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elcs1nal3jm7f">
        <rect
          x={103.38}
          y={401.29}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 403.17px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="ell7s0s810uo">
        <rect
          x={115.17}
          y={407.68}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 409.56px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el2vjupfegn6g">
        <rect
          x={103.38}
          y={407.68}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 409.56px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elx21e92kc0oq">
        <rect
          x={115.17}
          y={414.07}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 415.95px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elk0u3eu4rmyr">
        <rect
          x={103.38}
          y={414.07}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 415.95px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1ryix94va54">
        <rect
          x={115.17}
          y={420.47}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 422.35px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elrahordt9a">
        <rect
          x={103.38}
          y={420.47}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 422.35px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1unkuzj1c4ti">
        <rect
          x={115.17}
          y={426.86}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 428.74px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el61iv22x7im">
        <rect
          x={103.38}
          y={426.86}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 428.74px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el9ncdk5x5bph">
        <rect
          x={115.17}
          y={433.25}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 435.13px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elpgyifgx6hme">
        <rect
          x={103.38}
          y={433.25}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 435.13px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el4ysuw4svffj">
        <rect
          x={115.17}
          y={439.64}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "119.775px 441.52px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elyvem76xsufe">
        <rect
          x={103.38}
          y={439.64}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "107.985px 441.52px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el87elvanyyfi">
        <rect
          x={74.69}
          y={351.97}
          width={23.74}
          height={106.48}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "86.56px 405.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={77.07}
        y={439.64}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 441.52px 0px",
        }}
        id="el2pj777ucv0m"
        className="animable"
      />
      <rect
        x={86.75}
        y={439.64}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 441.52px 0px",
        }}
        id="el6l8yxc7a47h"
        className="animable"
      />
      <rect
        x={77.07}
        y={433.25}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 435.13px 0px",
        }}
        id="elbb3ip28pfe"
        className="animable"
      />
      <rect
        x={86.75}
        y={433.25}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 435.13px 0px",
        }}
        id="elcsz898ut5x7"
        className="animable"
      />
      <rect
        x={77.07}
        y={426.86}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 428.74px 0px",
        }}
        id="elpg8va3wht9"
        className="animable"
      />
      <rect
        x={86.75}
        y={426.86}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 428.74px 0px",
        }}
        id="elkjudvmt1lhc"
        className="animable"
      />
      <rect
        x={77.07}
        y={420.47}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 422.35px 0px",
        }}
        id="elr9d9j8twecb"
        className="animable"
      />
      <rect
        x={86.75}
        y={420.47}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 422.35px 0px",
        }}
        id="elkfw84jwpz5p"
        className="animable"
      />
      <rect
        x={77.07}
        y={414.07}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 415.95px 0px",
        }}
        id="elikgm0mbc4rc"
        className="animable"
      />
      <rect
        x={86.75}
        y={414.07}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 415.95px 0px",
        }}
        id="elqxgk1sm34wc"
        className="animable"
      />
      <rect
        x={77.07}
        y={407.68}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 409.56px 0px",
        }}
        id="elrzs8v4ln4e8"
        className="animable"
      />
      <rect
        x={86.75}
        y={407.68}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 409.56px 0px",
        }}
        id="elqoliz8uw35r"
        className="animable"
      />
      <rect
        x={77.07}
        y={401.29}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 403.17px 0px",
        }}
        id="elrmdovtozqqr"
        className="animable"
      />
      <rect
        x={86.75}
        y={401.29}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 403.17px 0px",
        }}
        id="elbucld2wc63d"
        className="animable"
      />
      <rect
        x={77.07}
        y={394.9}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 396.78px 0px",
        }}
        id="elqhg5bpw475"
        className="animable"
      />
      <rect
        x={86.75}
        y={394.9}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 396.78px 0px",
        }}
        id="eloz029b9i8b"
        className="animable"
      />
      <rect
        x={77.07}
        y={388.51}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 390.39px 0px",
        }}
        id="elrdla3my8ibl"
        className="animable"
      />
      <rect
        x={86.75}
        y={388.51}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 390.39px 0px",
        }}
        id="el94gg5ztfg95"
        className="animable"
      />
      <rect
        x={77.07}
        y={382.12}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 384px 0px",
        }}
        id="eltvpg62u2h9d"
        className="animable"
      />
      <rect
        x={86.75}
        y={382.12}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 384px 0px",
        }}
        id="eltroh83adfx"
        className="animable"
      />
      <rect
        x={77.07}
        y={375.73}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 377.61px 0px",
        }}
        id="el0fngsk2v6aip"
        className="animable"
      />
      <rect
        x={86.75}
        y={375.73}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 377.61px 0px",
        }}
        id="eljhc97bqnb07"
        className="animable"
      />
      <rect
        x={77.07}
        y={369.33}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 371.21px 0px",
        }}
        id="el1pscjwz35hy"
        className="animable"
      />
      <rect
        x={86.75}
        y={369.33}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 371.21px 0px",
        }}
        id="elfd7tnd7ycf"
        className="animable"
      />
      <rect
        x={77.07}
        y={362.94}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 364.82px 0px",
        }}
        id="elkfg5360qaz"
        className="animable"
      />
      <rect
        x={86.75}
        y={362.94}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 364.82px 0px",
        }}
        id="ela9ajsdwh95m"
        className="animable"
      />
      <rect
        x={77.07}
        y={356.55}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "80.85px 358.43px 0px",
        }}
        id="el16onzm9k80h"
        className="animable"
      />
      <rect
        x={86.75}
        y={356.55}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "90.53px 358.43px 0px",
        }}
        id="elwlj52zy0po"
        className="animable"
      />
      <g id="eltx58g4mou1">
        <rect
          x={616.07}
          y={331.96}
          width={18.12}
          height={21.4}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "625.13px 342.66px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elftjag598rog">
        <rect
          x={604.59}
          y={331.96}
          width={11.49}
          height={22.19}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "610.335px 343.055px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elt9qu8e2dgw">
        <rect
          x={603.82}
          y={341.41}
          width={11.4}
          height={12.74}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "609.52px 347.78px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elji7fdp34tjq">
        <rect
          x={596.71}
          y={341.41}
          width={7.11}
          height={12.74}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "600.265px 347.78px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elgiikixqrflv">
        <rect
          x={611.84}
          y={351.97}
          width={29.3}
          height={106.48}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "626.49px 405.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el2o2xror9xxq">
        <rect
          x={628.58}
          y={356.55}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 358.43px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el3cdm147chtm">
        <rect
          x={616.79}
          y={356.55}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 358.43px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elnay73ibzgwh">
        <rect
          x={628.58}
          y={362.94}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 364.82px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eleqm49eupm0v">
        <rect
          x={616.79}
          y={362.94}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 364.82px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eloh6xqyeasy">
        <rect
          x={628.58}
          y={369.33}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 371.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0br7iwuxsg6">
        <rect
          x={616.79}
          y={369.33}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 371.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elwwvczs1m3k">
        <rect
          x={628.58}
          y={375.73}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 377.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el5i0q2h97r1a">
        <rect
          x={616.79}
          y={375.73}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 377.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="ela4zgxhch6u">
        <rect
          x={628.58}
          y={382.12}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 384px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el7zzc4vccu6">
        <rect
          x={616.79}
          y={382.12}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 384px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elvc8994adoia">
        <rect
          x={628.58}
          y={388.51}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 390.39px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elh6g5spioae">
        <rect
          x={616.79}
          y={388.51}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 390.39px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el5qq6jaso4g6">
        <rect
          x={628.58}
          y={394.9}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 396.78px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elncfp0dvywa">
        <rect
          x={616.79}
          y={394.9}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 396.78px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el9wy3h5twdf8">
        <rect
          x={628.58}
          y={401.29}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 403.17px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0765ca3ubfkc">
        <rect
          x={616.79}
          y={401.29}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 403.17px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el51fy7pgpt4x">
        <rect
          x={628.58}
          y={407.68}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 409.56px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eld01ac33tzgk">
        <rect
          x={616.79}
          y={407.68}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 409.56px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1xai0xbueef">
        <rect
          x={628.58}
          y={414.07}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 415.95px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="ellx9jziso0e">
        <rect
          x={616.79}
          y={414.07}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 415.95px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el3ul8qc4edr2">
        <rect
          x={628.58}
          y={420.47}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 422.35px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0znou54vqeim">
        <rect
          x={616.79}
          y={420.47}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 422.35px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el6by6qqq6y87">
        <rect
          x={628.58}
          y={426.86}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 428.74px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elley36yodp9a">
        <rect
          x={616.79}
          y={426.86}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 428.74px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el4un2uf7mu4w">
        <rect
          x={628.58}
          y={433.25}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 435.13px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elfgni7z6v4z">
        <rect
          x={616.79}
          y={433.25}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 435.13px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el37vjgb571ab">
        <rect
          x={628.58}
          y={439.64}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "633.185px 441.52px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el03g6okhfu278">
        <rect
          x={616.79}
          y={439.64}
          width={9.21}
          height={3.76}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "621.395px 441.52px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elk0u5q7kkjh">
        <rect
          x={588.1}
          y={351.97}
          width={23.74}
          height={106.48}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "599.97px 405.21px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={590.48}
        y={439.64}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 441.52px 0px",
        }}
        id="el95fmea8wix6"
        className="animable"
      />
      <rect
        x={600.16}
        y={439.64}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 441.52px 0px",
        }}
        id="elwgbz2s5wtxj"
        className="animable"
      />
      <rect
        x={590.48}
        y={433.25}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 435.13px 0px",
        }}
        id="elg7j2gh0ui6"
        className="animable"
      />
      <rect
        x={600.16}
        y={433.25}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 435.13px 0px",
        }}
        id="ely5h29d1rcw"
        className="animable"
      />
      <rect
        x={590.48}
        y={426.86}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 428.74px 0px",
        }}
        id="elx2j5qribttr"
        className="animable"
      />
      <rect
        x={600.16}
        y={426.86}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 428.74px 0px",
        }}
        id="elhmbk9ld9qei"
        className="animable"
      />
      <rect
        x={590.48}
        y={420.47}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 422.35px 0px",
        }}
        id="elznoqz879k9"
        className="animable"
      />
      <rect
        x={600.16}
        y={420.47}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 422.35px 0px",
        }}
        id="el6wc6dy65jva"
        className="animable"
      />
      <rect
        x={590.48}
        y={414.07}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 415.95px 0px",
        }}
        id="el2do77n3vaev"
        className="animable"
      />
      <rect
        x={600.16}
        y={414.07}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 415.95px 0px",
        }}
        id="el2w88abyi2ai"
        className="animable"
      />
      <rect
        x={590.48}
        y={407.68}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 409.56px 0px",
        }}
        id="el8kc2grtsbb3"
        className="animable"
      />
      <rect
        x={600.16}
        y={407.68}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 409.56px 0px",
        }}
        id="elt5p2qexgnjq"
        className="animable"
      />
      <rect
        x={590.48}
        y={401.29}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 403.17px 0px",
        }}
        id="eldmtt0irgov"
        className="animable"
      />
      <rect
        x={600.16}
        y={401.29}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 403.17px 0px",
        }}
        id="eldmp3pv8rhc9"
        className="animable"
      />
      <rect
        x={590.48}
        y={394.9}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 396.78px 0px",
        }}
        id="elronz42s4ycg"
        className="animable"
      />
      <rect
        x={600.16}
        y={394.9}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 396.78px 0px",
        }}
        id="elmk2k09991g"
        className="animable"
      />
      <rect
        x={590.48}
        y={388.51}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 390.39px 0px",
        }}
        id="el24drygl1dpj"
        className="animable"
      />
      <rect
        x={600.16}
        y={388.51}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 390.39px 0px",
        }}
        id="elbp28qgw82rw"
        className="animable"
      />
      <rect
        x={590.48}
        y={382.12}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 384px 0px",
        }}
        id="eldgpme1g5hqc"
        className="animable"
      />
      <rect
        x={600.16}
        y={382.12}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 384px 0px",
        }}
        id="elbttmiryiyzo"
        className="animable"
      />
      <rect
        x={590.48}
        y={375.73}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 377.61px 0px",
        }}
        id="eldvs9hgyavd"
        className="animable"
      />
      <rect
        x={600.16}
        y={375.73}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 377.61px 0px",
        }}
        id="elf3gfcrjb5tr"
        className="animable"
      />
      <rect
        x={590.48}
        y={369.33}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 371.21px 0px",
        }}
        id="el2t67zwv4s3w"
        className="animable"
      />
      <rect
        x={600.16}
        y={369.33}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 371.21px 0px",
        }}
        id="elkiz2kfzjflo"
        className="animable"
      />
      <rect
        x={590.48}
        y={362.94}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 364.82px 0px",
        }}
        id="el21bu5o2nt5f"
        className="animable"
      />
      <rect
        x={600.16}
        y={362.94}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 364.82px 0px",
        }}
        id="elg2wq4belut9"
        className="animable"
      />
      <rect
        x={590.48}
        y={356.55}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "594.26px 358.43px 0px",
        }}
        id="eljihe9eypp1"
        className="animable"
      />
      <rect
        x={600.16}
        y={356.55}
        width={7.56}
        height={3.76}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "603.94px 358.43px 0px",
        }}
        id="eljdgonxtx2k"
        className="animable"
      />
      <g id="elw2ixe3zg4j">
        <rect
          x={647.04}
          y={389.07}
          width={34.56}
          height={69.38}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "664.32px 423.76px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elasekibxbvmr">
        <rect
          x={670.05}
          y={395.08}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "673.11px 397.205px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elcnx4c19cjo5">
        <rect
          x={670.05}
          y={404.16}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "673.11px 406.285px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elepqmhhaxzg">
        <rect
          x={670.05}
          y={413.24}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "673.11px 415.365px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="ellu0ghzqib3r">
        <rect
          x={670.05}
          y={422.32}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "673.11px 424.445px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elgfywa5t6mbh">
        <rect
          x={670.05}
          y={431.4}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "673.11px 433.525px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elnzynzdywqo">
        <rect
          x={670.05}
          y={440.48}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "673.11px 442.605px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elahe39vj3bo">
        <rect
          x={670.05}
          y={449.56}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "673.11px 451.685px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el6blvqmm8ag9">
        <rect
          x={661.25}
          y={395.08}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "664.31px 397.205px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el1q5gfhyqbzf">
        <rect
          x={661.25}
          y={404.16}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "664.31px 406.285px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elpiikdf8sc1">
        <rect
          x={661.25}
          y={413.24}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "664.31px 415.365px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elmh8xt2cbjhs">
        <rect
          x={661.25}
          y={422.32}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "664.31px 424.445px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el65tgutiuby8">
        <rect
          x={661.25}
          y={431.4}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "664.31px 433.525px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el0neimt2hxute">
        <rect
          x={661.25}
          y={440.48}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "664.31px 442.605px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elxukq3xtev">
        <rect
          x={661.25}
          y={449.56}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "664.31px 451.685px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elsq2zps297qs">
        <rect
          x={652.47}
          y={395.08}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "655.53px 397.205px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elwm63ay2tye">
        <rect
          x={652.47}
          y={404.16}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "655.53px 406.285px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elbwilacuflbo">
        <rect
          x={652.47}
          y={413.24}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "655.53px 415.365px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elcosku8f4ev5">
        <rect
          x={652.47}
          y={422.32}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "655.53px 424.445px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elgj8ybgf5lmc">
        <rect
          x={652.47}
          y={431.4}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "655.53px 433.525px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elie6y9utnt9k">
        <rect
          x={652.47}
          y={440.48}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "655.53px 442.605px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elx56j44tbg5">
        <rect
          x={652.47}
          y={449.56}
          width={6.12}
          height={4.25}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "655.53px 451.685px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el17u21nhwm28">
        <rect
          x={647.04}
          y={381.84}
          width={23.01}
          height={7.23}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "658.545px 385.455px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="el562gjhz6yhi">
        <rect
          x={647.04}
          y={377.37}
          width={14.59}
          height={4.48}
          style={{
            fill: "rgb(235, 235, 235)",
            transformOrigin: "654.335px 379.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elc41fcab3hmi">
        <rect
          x={622.79}
          y={389.07}
          width={24.25}
          height={69.38}
          style={{
            fill: "rgb(166, 166, 166)",
            transformOrigin: "634.915px 423.76px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={625.27}
        y={448.88}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "627.76px 451.005px 0px",
        }}
        id="el05w0rg7qcb4f"
        className="animable"
      />
      <rect
        x={625.27}
        y={439.8}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "627.76px 441.925px 0px",
        }}
        id="elrrgkn7fk3io"
        className="animable"
      />
      <rect
        x={625.27}
        y={430.72}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "627.76px 432.845px 0px",
        }}
        id="elkbd2vf9yasm"
        className="animable"
      />
      <rect
        x={625.27}
        y={421.64}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "627.76px 423.765px 0px",
        }}
        id="el9kvlfujyvmu"
        className="animable"
      />
      <rect
        x={625.27}
        y={412.56}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "627.76px 414.685px 0px",
        }}
        id="el3jv6x55y2bq"
        className="animable"
      />
      <rect
        x={625.27}
        y={403.48}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "627.76px 405.605px 0px",
        }}
        id="elyuncu6ye1g"
        className="animable"
      />
      <rect
        x={625.27}
        y={394.4}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "627.76px 396.525px 0px",
        }}
        id="elq1ps0oujs7b"
        className="animable"
      />
      <rect
        x={632.43}
        y={448.88}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "634.92px 451.005px 0px",
        }}
        id="elafcmxhsktfa"
        className="animable"
      />
      <rect
        x={632.43}
        y={439.8}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "634.92px 441.925px 0px",
        }}
        id="el7w8sr1n832l"
        className="animable"
      />
      <rect
        x={632.43}
        y={430.72}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "634.92px 432.845px 0px",
        }}
        id="elin5ctlfhsi"
        className="animable"
      />
      <rect
        x={632.43}
        y={421.64}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "634.92px 423.765px 0px",
        }}
        id="el46zu6sm6eb"
        className="animable"
      />
      <rect
        x={632.43}
        y={412.56}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "634.92px 414.685px 0px",
        }}
        id="elx5af7ywwkke"
        className="animable"
      />
      <rect
        x={632.43}
        y={403.48}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "634.92px 405.605px 0px",
        }}
        id="el6eeslcyk9kw"
        className="animable"
      />
      <rect
        x={632.43}
        y={394.4}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "634.92px 396.525px 0px",
        }}
        id="elj7xkqoksmba"
        className="animable"
      />
      <rect
        x={639.58}
        y={448.88}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "642.07px 451.005px 0px",
        }}
        id="elg4eew051pf"
        className="animable"
      />
      <rect
        x={639.58}
        y={439.8}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "642.07px 441.925px 0px",
        }}
        id="eliro0kg8gcc8"
        className="animable"
      />
      <rect
        x={639.58}
        y={430.72}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "642.07px 432.845px 0px",
        }}
        id="elkt64ryfl1a"
        className="animable"
      />
      <rect
        x={639.58}
        y={421.64}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "642.07px 423.765px 0px",
        }}
        id="elfjx67nyptqa"
        className="animable"
      />
      <rect
        x={639.58}
        y={412.56}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "642.07px 414.685px 0px",
        }}
        id="elawmwbgtk307"
        className="animable"
      />
      <rect
        x={639.58}
        y={403.48}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "642.07px 405.605px 0px",
        }}
        id="elokjd3k8ppht"
        className="animable"
      />
      <rect
        x={639.58}
        y={394.4}
        width={4.98}
        height={4.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "642.07px 396.525px 0px",
        }}
        id="elckw5em875ua"
        className="animable"
      />
      <g id="elxrkrjiigfm">
        <rect
          x={626.47}
          y={381.84}
          width={20.57}
          height={7.23}
          style={{
            fill: "rgb(199, 199, 199)",
            transformOrigin: "636.755px 385.455px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
      <g id="elliv8zqo72g">
        <rect
          x={635.89}
          y={377.37}
          width={11.15}
          height={4.48}
          style={{
            fill: "rgb(219, 219, 219)",
            transformOrigin: "641.465px 379.61px 0px",
            transform: "rotate(180deg)",
          }}
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--hospital-building--inject-47"
      style={{
        transformOrigin: "374.995px 260.06px 0px",
      }}
      className="animable"
    >
      <rect
        x={116.42}
        y={195.06}
        width={517.17}
        height={34.12}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "375.005px 212.12px 0px",
        }}
        id="el5qqfmge63r4"
        className="animable"
      />
      <g id="elu4romzzv4l">
        <rect
          x={116.42}
          y={195.06}
          width={517.17}
          height={34.12}
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.7,
            transformOrigin: "375.005px 212.12px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="elum5g5hyzrj">
        <polygon
          points="633.59 195.06 116.42 195.06 116.42 204.74 633.59 201.16 633.59 195.06"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375.005px 199.9px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={110.82}
        y={187.86}
        width={528.36}
        height={7.21}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "375px 191.465px 0px",
        }}
        id="el0pb76xx7ejt"
        className="animable"
      />
      <rect
        x={160.69}
        y={177.26}
        width={47.22}
        height={10.59}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "184.3px 182.555px 0px",
        }}
        id="elpnof8oy174"
        className="animable"
      />
      <rect
        x={167.83}
        y={171.01}
        width={6.68}
        height={6.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "171.17px 174.135px 0px",
        }}
        id="elo770s38slob"
        className="animable"
      />
      <rect
        x={194.08}
        y={171.01}
        width={6.68}
        height={6.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "197.42px 174.135px 0px",
        }}
        id="elc1731sw5ffn"
        className="animable"
      />
      <rect
        x={564.8}
        y={177.26}
        width={47.22}
        height={10.59}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "588.41px 182.555px 0px",
        }}
        id="elj0db1zazp69"
        className="animable"
      />
      <rect
        x={571.94}
        y={171.01}
        width={6.68}
        height={6.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "575.28px 174.135px 0px",
        }}
        id="el2uqjazmvp35"
        className="animable"
      />
      <rect
        x={598.2}
        y={171.01}
        width={6.68}
        height={6.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "601.54px 174.135px 0px",
        }}
        id="el09bkbeu8y94v"
        className="animable"
      />
      <rect
        x={506.26}
        y={177.26}
        width={47.22}
        height={10.59}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "529.87px 182.555px 0px",
        }}
        id="elcbeeuk5q4l9"
        className="animable"
      />
      <rect
        x={513.4}
        y={171.01}
        width={6.68}
        height={6.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "516.74px 174.135px 0px",
        }}
        id="elqyq92pplcu"
        className="animable"
      />
      <rect
        x={539.65}
        y={171.01}
        width={6.68}
        height={6.25}
        style={{
          fill: "rgb(199, 199, 199)",
          transformOrigin: "542.99px 174.135px 0px",
        }}
        id="eltj1zi1nsbja"
        className="animable"
      />
      <rect
        x={83.11}
        y={236.39}
        width={583.78}
        height={222.04}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "375px 347.41px 0px",
        }}
        id="elqcfqpbbxp78"
        className="animable"
      />
      <g id="eluxy041bm2r">
        <rect
          x={83.11}
          y={236.39}
          width={583.78}
          height={222.04}
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.7,
            transformOrigin: "375px 347.41px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="elv81gyelz5s">
        <rect
          x={83.11}
          y={426.81}
          width={583.78}
          height={31.62}
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 442.62px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={77.51}
        y={229.19}
        width={594.97}
        height={7.21}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "374.995px 232.795px 0px",
        }}
        id="el2vy0kqa4p1u"
        className="animable"
      />
      <g id="elrxik7rgynyh">
        <polygon
          points="666.89 236.39 83.11 236.39 83.11 246.07 666.89 242.49 666.89 236.39"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 241.23px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={93.72}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "106.53px 276.045px 0px",
        }}
        id="el0ffh8vc4kfo9"
        className="animable"
      />
      <rect
        x={121.25}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "134.06px 276.045px 0px",
        }}
        id="el3w5c9kyldy2"
        className="animable"
      />
      <rect
        x={148.78}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "161.59px 276.045px 0px",
        }}
        id="eloguf9xf1fgb"
        className="animable"
      />
      <rect
        x={183.71}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "196.52px 276.045px 0px",
        }}
        id="ellsgndotxw3r"
        className="animable"
      />
      <rect
        x={211.24}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "224.05px 276.045px 0px",
        }}
        id="eliv9ixfvwxjt"
        className="animable"
      />
      <rect
        x={238.77}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "251.58px 276.045px 0px",
        }}
        id="elgq676xohss8"
        className="animable"
      />
      <rect
        x={93.72}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "106.53px 326.705px 0px",
        }}
        id="elt8350gznx98"
        className="animable"
      />
      <rect
        x={121.25}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "134.06px 326.705px 0px",
        }}
        id="elgi2g27yddlj"
        className="animable"
      />
      <rect
        x={148.78}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "161.59px 326.705px 0px",
        }}
        id="eldhsksqszso"
        className="animable"
      />
      <rect
        x={183.71}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "196.52px 326.705px 0px",
        }}
        id="elfwcwfbx2clg"
        className="animable"
      />
      <rect
        x={211.24}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "224.05px 326.705px 0px",
        }}
        id="elk42g6oacd3"
        className="animable"
      />
      <rect
        x={238.77}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "251.58px 326.705px 0px",
        }}
        id="el0rzbpson1eib"
        className="animable"
      />
      <rect
        x={93.72}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "106.53px 377.355px 0px",
        }}
        id="elfdj3gzj4sqc"
        className="animable"
      />
      <rect
        x={121.25}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "134.06px 377.355px 0px",
        }}
        id="el7brdi9phake"
        className="animable"
      />
      <rect
        x={148.78}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "161.59px 377.355px 0px",
        }}
        id="elbwzeybkk1dn"
        className="animable"
      />
      <rect
        x={183.71}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "196.52px 377.355px 0px",
        }}
        id="elfus8n1qluz5"
        className="animable"
      />
      <rect
        x={211.24}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "224.05px 377.355px 0px",
        }}
        id="eln1etqy2xiae"
        className="animable"
      />
      <rect
        x={238.77}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "251.58px 377.355px 0px",
        }}
        id="elndoykbb889r"
        className="animable"
      />
      <rect
        x={485.61}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "498.42px 276.045px 0px",
        }}
        id="ele53dyum7nih"
        className="animable"
      />
      <rect
        x={513.14}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "525.95px 276.045px 0px",
        }}
        id="el2ei8otnsiu4"
        className="animable"
      />
      <rect
        x={540.67}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "553.48px 276.045px 0px",
        }}
        id="eli84qa50v4ok"
        className="animable"
      />
      <rect
        x={575.6}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "588.41px 276.045px 0px",
        }}
        id="el8ewh1ct9bov"
        className="animable"
      />
      <rect
        x={603.13}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "615.94px 276.045px 0px",
        }}
        id="elpqiuv1qko9h"
        className="animable"
      />
      <rect
        x={630.66}
        y={257.29}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "643.47px 276.045px 0px",
        }}
        id="el5n6cjriap8"
        className="animable"
      />
      <rect
        x={485.61}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "498.42px 326.705px 0px",
        }}
        id="eli6wwd65rjr"
        className="animable"
      />
      <rect
        x={513.14}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "525.95px 326.705px 0px",
        }}
        id="eljs6286tvysh"
        className="animable"
      />
      <rect
        x={540.67}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "553.48px 326.705px 0px",
        }}
        id="elep81ah84heb"
        className="animable"
      />
      <rect
        x={575.6}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "588.41px 326.705px 0px",
        }}
        id="eleawt5ucjlnw"
        className="animable"
      />
      <rect
        x={603.13}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "615.94px 326.705px 0px",
        }}
        id="elepr0nop9t9k"
        className="animable"
      />
      <rect
        x={630.66}
        y={307.95}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "643.47px 326.705px 0px",
        }}
        id="elidzhic9lqh"
        className="animable"
      />
      <rect
        x={485.61}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "498.42px 377.355px 0px",
        }}
        id="el55kiuu8txf9"
        className="animable"
      />
      <rect
        x={513.14}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "525.95px 377.355px 0px",
        }}
        id="el7kze58lhakk"
        className="animable"
      />
      <rect
        x={540.67}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "553.48px 377.355px 0px",
        }}
        id="ely3o02cm8zwj"
        className="animable"
      />
      <rect
        x={575.6}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "588.41px 377.355px 0px",
        }}
        id="el3d84uqzczt"
        className="animable"
      />
      <rect
        x={603.13}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "615.94px 377.355px 0px",
        }}
        id="elwg52sdgtnef"
        className="animable"
      />
      <rect
        x={630.66}
        y={358.6}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "643.47px 377.355px 0px",
        }}
        id="elit6k9iez1rn"
        className="animable"
      />
      <rect
        x={83.11}
        y={299.15}
        width={583.78}
        height={4.33}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "375px 301.315px 0px",
        }}
        id="el88l2p24qp4m"
        className="animable"
      />
      <rect
        x={83.11}
        y={349.8}
        width={583.78}
        height={4.33}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "375px 351.965px 0px",
        }}
        id="elqod0bp30lm"
        className="animable"
      />
      <rect
        x={83.11}
        y={400.46}
        width={583.78}
        height={4.33}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "375px 402.625px 0px",
        }}
        id="elodr5ub89nwd"
        className="animable"
      />
      <g id="el3ydz3x2t4rs">
        <polygon
          points="666.89 303.48 83.11 303.48 83.11 306.6 666.89 305.04 666.89 303.48"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 305.04px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="eln39a5hj0vmo">
        <polygon
          points="666.89 354.13 83.11 354.13 83.11 357.25 666.89 355.69 666.89 354.13"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 355.69px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="eljw7192chngn">
        <polygon
          points="666.89 404.79 83.11 404.79 83.11 407.9 666.89 406.35 666.89 404.79"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 406.345px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="elda3qp83dqdt">
        <path
          d="M93.72,288.78l25.62-25.62v11.36L99.06,294.8H93.72Zm31.49-31.49-4,4v11.36l15.33-15.32Zm68.61,138.82h11.37l31.67-31.67V358.6h-5.53Zm45-33.58,3.93-3.93h-3.93Zm5.71-17.08h11.37l8.54-8.54V325.54Zm249.83-88.16-8.7,8.7v11.36l20.07-20.06Zm16.92,138.82v-2.79l-2.79,2.79Zm1.91,0h6.67l19-18.95V365.79l-25.62,25.62ZM546,358.6l-5.28,5.28v11.37l16.65-16.65Zm20.34-13.15v-7.19l-7.19,7.19ZM575.6,329v11.37l25.62-25.62V308H596.6Zm27.53-16.16L608,308h-4.84Zm18-18,7.63-7.63V275.8l-19,19Zm26.14-37.51-16.6,16.6v11.37l25.62-25.62v-2.35Zm-3.49,138.82h11.37l1.14-1.14V383.6Zm-550-85.9v5.69l8-7.95H96Zm21.1-15.41,4.52-4.52v-5.69L109.13,294.8Zm31.82-37.51-25.39,25.39v5.69l25.62-25.62v-5.46Zm2.14,0v3.55l3.55-3.55Zm336.83,65.47v5.69l20.5-20.5h-5.69Zm33.65-28,19.5-19.5v-5.69L513.57,294.8Zm31.82-37.51L540.67,267.7v5.69l16.11-16.1Zm59.77,138.82,17.9-17.9v-5.69l-23.59,23.59Zm31.82-37.51-12,12v5.69l17.7-17.7Zm13.15-13.15h.46V345ZM538.76,396.11v-5.35l-5.35,5.35Zm1.91-1.57,25.62-25.62v-5.69l-25.62,25.62Zm34.93-34.93,1-1h-1Zm14.16-14.16L601.22,334V328.3l-17.15,17.15ZM621.57,308l-18.44,18.44v5.69L627.26,308Zm13.15-13.15h5.69l15.87-15.87v-5.69ZM93.72,326v1.3L113,308h-1.3Zm68.67-68.67L124.88,294.8h1.3l20.69-20.69,1.91-1.91,14.91-14.91Zm53.84,138.82,20.63-20.63v-1.3l-21.93,21.93Zm36.21-37.51-13.67,13.67v1.3l15-15ZM150.56,396.11l23.84-23.84V371l-25.14,25.14Zm36.21-37.51-3.06,3.06V363l4.36-4.36Zm14.45-13.15,8.11-8.11V336l-9.41,9.41Zm10-11.32v1.3l25.62-25.62v-1.3Zm39.33-39.33h1.3l12.52-12.52V281Zm-148,101.31,16.79-16.79v-5.69L96.86,396.11Zm31.82-37.51-13.12,13.12v5.69l18.81-18.81Zm14.41-13.15h4.43l21.19-21.19v-5.69l-25.62,25.62ZM185,308l-1.31,1.31V315l7-7Zm18.84-13.15,5.47-5.47v-5.69L198.17,294.8Zm31.82-37.51-24.44,24.44v5.69l25.62-25.61v-4.52Zm3.09,0v2.61l2.61-2.61ZM224.3,396.11l12.56-12.56v-5.69l-18.25,18.25Zm31.82-37.51L238.77,376v5.69l23-23Zm.13,37.51h1.3l6.84-6.84V388Zm244.08,0,10.9-10.9v-1.3L499,396.11Zm36.21-37.51L513.14,382v1.3l24.7-24.7ZM551,345.45l15.3-15.3v-1.3l-16.6,16.6Zm36.2-37.5L575.6,319.54v1.3L588.49,308Zm14-13.15v-.88l-.88.88Zm1.91-1.49,25.62-25.61v-1.3L603.13,292Zm34.73-36-7.2,7.2v1.3l8.5-8.5ZM603.13,376.14l-1.91,1.91-18.06,18.06h1.3l16.76-16.76,1.91-1.91L622,358.6h-1.3Zm30.69-30.69h1.3l21.16-21.16V323Zm3.31,50.66h1.3l17.85-17.85V377Z"
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.2,
            transformOrigin: "375.03px 326.72px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="el8gvys7rbtrq">
        <polygon
          points="270.86 458.46 274.36 458.46 274.36 195.06 267.03 195.06 270.86 458.46"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "270.695px 326.76px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="el27skda37g8u">
        <polygon
          points="479.14 458.46 475.64 458.46 475.64 195.06 482.97 195.06 479.14 458.46"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "479.305px 326.76px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={304.81}
        y={87.92}
        width={140.37}
        height={28.04}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "374.995px 101.94px 0px",
        }}
        id="elz8gtc7kfog"
        className="animable"
      />
      <g id="el9qr9oajjhd6">
        <rect
          x={304.81}
          y={87.92}
          width={140.37}
          height={28.04}
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.6,
            transformOrigin: "374.995px 101.94px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="elc5hhmu3bkbr">
        <polygon
          points="445.19 87.92 304.81 87.92 304.81 97.6 445.19 94.02 445.19 87.92"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 92.76px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={299.22}
        y={80.72}
        width={151.56}
        height={7.21}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "375px 84.325px 0px",
        }}
        id="elvr34wltxyg"
        className="animable"
      />
      <rect
        x={274.36}
        y={140.81}
        width={201.28}
        height={317.62}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "375px 299.62px 0px",
        }}
        id="elasl9vrypu6b"
        className="animable"
      />
      <g id="elsu4znvuvwc">
        <rect
          x={274.36}
          y={140.81}
          width={201.28}
          height={317.62}
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.7,
            transformOrigin: "375px 299.62px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={274.36}
        y={121.99}
        width={18.61}
        height={336.44}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "283.665px 290.21px 0px",
        }}
        id="el38j4zsh8vr9"
        className="animable"
      />
      <g id="elchpmjyrraiq">
        <rect
          x={274.36}
          y={121.99}
          width={18.61}
          height={336.44}
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.8,
            transformOrigin: "283.665px 290.21px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={457.03}
        y={121.99}
        width={18.61}
        height={336.44}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "466.335px 290.21px 0px",
        }}
        id="elhi12oxydj84"
        className="animable"
      />
      <g id="el3y6o87sigip">
        <rect
          x={457.03}
          y={121.99}
          width={18.61}
          height={336.44}
          style={{
            fill: "rgb(255, 255, 255)",
            opacity: 0.8,
            transformOrigin: "466.335px 290.21px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={292.97}
        y={110.35}
        width={164.05}
        height={30.45}
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "374.995px 125.575px 0px",
        }}
        id="eljd08i7e6ck"
        className="animable"
      />
      <path
        d="M311.49,134v-16.3a1.5,1.5,0,0,1,1.52-1.52,1.52,1.52,0,0,1,1.55,1.52v6.63h7.15v-6.63a1.5,1.5,0,0,1,1.52-1.52,1.52,1.52,0,0,1,1.55,1.52V134a1.53,1.53,0,0,1-1.55,1.52,1.51,1.51,0,0,1-1.52-1.52v-6.63h-7.15V134a1.53,1.53,0,0,1-1.55,1.52A1.51,1.51,0,0,1,311.49,134Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "318.135px 125.85px 0px",
        }}
        id="elbsh5o1jldua"
        className="animable"
      />
      <path
        d="M345.5,118.59a10.15,10.15,0,0,1,0,14,9,9,0,0,1-6.6,3,9.29,9.29,0,0,1-6.77-3,10.29,10.29,0,0,1,0-14,9.21,9.21,0,0,1,6.77-3A9,9,0,0,1,345.5,118.59Zm-.36,7a7.15,7.15,0,0,0-1.88-4.83,6,6,0,0,0-4.36-2,6,6,0,0,0-4.48,2,7,7,0,0,0-1.88,4.83,6.92,6.92,0,0,0,1.88,4.81,5.9,5.9,0,0,0,8.84,0A7.06,7.06,0,0,0,345.14,125.58Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "338.841px 125.59px 0px",
        }}
        id="el51fthd9qfck"
        className="animable"
      />
      <path
        d="M353,130.72a1.43,1.43,0,0,1,2-.19,9,9,0,0,0,5.28,2.12,5.93,5.93,0,0,0,3.45-1,2.49,2.49,0,0,0,1.19-2,1.59,1.59,0,0,0-.25-.88,2.6,2.6,0,0,0-.83-.83,11,11,0,0,0-3.78-1.3H360a14.84,14.84,0,0,1-3.56-1.08,5.88,5.88,0,0,1-2.57-2.15,4.19,4.19,0,0,1-.64-2.26,5.12,5.12,0,0,1,2.21-4,8.18,8.18,0,0,1,4.78-1.46,10.84,10.84,0,0,1,6,2.21,1.42,1.42,0,0,1,.39,2,1.39,1.39,0,0,1-2,.41,8,8,0,0,0-4.45-1.76,5.27,5.27,0,0,0-3.09.93,2.2,2.2,0,0,0-1.05,1.75,1.32,1.32,0,0,0,.19.77,2.74,2.74,0,0,0,.75.72,9.55,9.55,0,0,0,3.45,1.21h.06a16.87,16.87,0,0,1,3.81,1.16,6.48,6.48,0,0,1,2.76,2.29,4.56,4.56,0,0,1,.66,2.35,5.33,5.33,0,0,1-2.37,4.28,8.62,8.62,0,0,1-5.11,1.58,11.91,11.91,0,0,1-7.07-2.76A1.47,1.47,0,0,1,353,130.72Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "360.162px 125.64px 0px",
        }}
        id="eltg8qezu1us9"
        className="animable"
      />
      <path
        d="M378.48,128h-3.4v6a1.53,1.53,0,0,1-3.06,0v-16.3a1.51,1.51,0,0,1,1.52-1.52h4.94a5.91,5.91,0,1,1,0,11.82Zm-3.4-3.06h3.4a2.85,2.85,0,1,0,0-5.69h-3.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "378.208px 125.854px 0px",
        }}
        id="elghj2ci4u40w"
        className="animable"
      />
      <path
        d="M388.31,117.71a1.5,1.5,0,0,1,1.52-1.52,1.54,1.54,0,0,1,1.55,1.52V134a1.55,1.55,0,0,1-1.55,1.52,1.51,1.51,0,0,1-1.52-1.52Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "389.845px 125.855px 0px",
        }}
        id="elhivs17vgceh"
        className="animable"
      />
      <path
        d="M408.37,119.26H404V134a1.52,1.52,0,0,1-3,0V119.26h-4.37a1.55,1.55,0,0,1-1.52-1.55,1.5,1.5,0,0,1,1.52-1.52h11.8a1.51,1.51,0,0,1,1.52,1.52A1.56,1.56,0,0,1,408.37,119.26Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "402.53px 125.732px 0px",
        }}
        id="el91068yopqwq"
        className="animable"
      />
      <path
        d="M421.68,131H415l-1.35,3.59a1.55,1.55,0,0,1-1.44,1,1.46,1.46,0,0,1-.52-.09,1.56,1.56,0,0,1-.91-2l6.1-16.26a1.54,1.54,0,0,1,1.46-1,1.52,1.52,0,0,1,1.47,1l6.1,16.26a1.56,1.56,0,0,1-.91,2,1.38,1.38,0,0,1-.52.09,1.48,1.48,0,0,1-1.41-1Zm-1.13-3L418.31,122l-2.23,5.94Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "418.345px 125.915px 0px",
        }}
        id="elzz317qkrwha"
        className="animable"
      />
      <path
        d="M429.67,134v-16.3a1.51,1.51,0,0,1,1.52-1.52,1.54,1.54,0,0,1,1.54,1.52v14.75h7.49a1.54,1.54,0,0,1,0,3.07h-9A1.51,1.51,0,0,1,429.67,134Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "435.653px 125.85px 0px",
        }}
        id="elv7mgr28nk8e"
        className="animable"
      />
      <g id="el4ui1o431xnv">
        <polygon
          points="453.53 458.43 457.03 458.43 457.03 140.81 449.72 151.22 453.53 458.43"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "453.375px 299.62px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="elx422ywfzaqp">
        <polygon
          points="296.47 458.43 292.97 458.43 292.97 140.81 300.28 151.22 296.47 458.43"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "296.625px 299.62px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={292.97}
        y={196.94}
        width={164.05}
        height={4.33}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "374.995px 199.105px 0px",
        }}
        id="elpsfni14jl2"
        className="animable"
      />
      <g id="elbyal0vzy6u6">
        <polygon
          points="457.03 201.27 292.97 201.27 292.97 204.39 457.03 202.83 457.03 201.27"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 202.83px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="elgihscj7heyg">
        <polygon
          points="457.03 259.44 292.97 259.44 292.97 262.56 457.03 261 457.03 259.44"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 261px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="elvs6z78950r">
        <polygon
          points="457.03 317.61 292.97 317.61 292.97 320.73 457.03 319.17 457.03 317.61"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 319.17px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={292.97}
        y={255.11}
        width={164.05}
        height={4.33}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "374.995px 257.275px 0px",
        }}
        id="elmj9adtyx10m"
        className="animable"
      />
      <rect
        x={309.24}
        y={151.26}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "322.05px 170.015px 0px",
        }}
        id="el97qd5ht8omd"
        className="animable"
      />
      <rect
        x={344.54}
        y={151.26}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "357.35px 170.015px 0px",
        }}
        id="elf1raoxh1gbs"
        className="animable"
      />
      <rect
        x={379.84}
        y={151.26}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "392.65px 170.015px 0px",
        }}
        id="elemvsmu4wsxn"
        className="animable"
      />
      <rect
        x={415.14}
        y={151.26}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "427.95px 170.015px 0px",
        }}
        id="el1j3wiaks5o"
        className="animable"
      />
      <rect
        x={309.24}
        y={209.44}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "322.05px 228.195px 0px",
        }}
        id="el9ce5l0k7w19"
        className="animable"
      />
      <rect
        x={344.54}
        y={209.44}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "357.35px 228.195px 0px",
        }}
        id="elywljln6d85"
        className="animable"
      />
      <rect
        x={379.84}
        y={209.44}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "392.65px 228.195px 0px",
        }}
        id="eld3fkcaqif5p"
        className="animable"
      />
      <rect
        x={415.14}
        y={209.44}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "427.95px 228.195px 0px",
        }}
        id="elei7tp25dinr"
        className="animable"
      />
      <rect
        x={309.24}
        y={267.61}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "322.05px 286.365px 0px",
        }}
        id="elodbs67nyze"
        className="animable"
      />
      <rect
        x={344.54}
        y={267.61}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "357.35px 286.365px 0px",
        }}
        id="elzpk38mek2o"
        className="animable"
      />
      <rect
        x={379.84}
        y={267.61}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "392.65px 286.365px 0px",
        }}
        id="elhqcuz4eql87"
        className="animable"
      />
      <rect
        x={415.14}
        y={267.61}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "427.95px 286.365px 0px",
        }}
        id="ely9gqmlw6gnb"
        className="animable"
      />
      <rect
        x={309.24}
        y={325.77}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "322.05px 344.525px 0px",
        }}
        id="elbu07zm2u3cv"
        className="animable"
      />
      <rect
        x={344.54}
        y={325.77}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "357.35px 344.525px 0px",
        }}
        id="elbmnkj58m8mf"
        className="animable"
      />
      <rect
        x={379.84}
        y={325.77}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "392.65px 344.525px 0px",
        }}
        id="el6pszvdk04lm"
        className="animable"
      />
      <rect
        x={415.14}
        y={325.77}
        width={25.62}
        height={37.51}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "427.95px 344.525px 0px",
        }}
        id="elrdfoqvmfjea"
        className="animable"
      />
      <g id="elj64zibpdaw">
        <polygon
          points="457.03 317.61 292.97 317.61 292.97 320.72 457.03 319.17 457.03 317.61"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 319.165px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={292.97}
        y={313.28}
        width={164.05}
        height={4.33}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "374.995px 315.445px 0px",
        }}
        id="elakv5s5twbd7"
        className="animable"
      />
      <g id="el7de0yu7ak6f">
        <polygon
          points="457.03 375.78 292.97 375.78 292.97 378.9 457.03 377.34 457.03 375.78"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 377.34px 0px",
          }}
          className="animable"
        />
      </g>
      <g id="el9m1tnw44cw">
        <polygon
          points="457.03 375.77 292.97 375.77 292.97 378.89 457.03 377.33 457.03 375.77"
          style={{
            fill: "rgb(153, 113, 225)",
            opacity: 0.5,
            transformOrigin: "375px 377.33px 0px",
          }}
          className="animable"
        />
      </g>
      <rect
        x={292.97}
        y={371.44}
        width={164.05}
        height={4.33}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "374.995px 373.605px 0px",
        }}
        id="eldqxjoc1azzq"
        className="animable"
      />
      <rect
        x={341.97}
        y={397.83}
        width={64.61}
        height={60.6}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "374.275px 428.13px 0px",
        }}
        id="el7pgl6ie4ei"
        className="animable"
      />
      <rect
        x={341.97}
        y={401.82}
        width={30.65}
        height={56.61}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "357.295px 430.125px 0px",
        }}
        id="elary9xnft9x"
        className="animable"
      />
      <rect
        x={375.94}
        y={401.82}
        width={30.65}
        height={56.61}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "391.265px 430.125px 0px",
        }}
        id="el1mzwuniow6oi"
        className="animable"
      />
      <rect
        x={332.09}
        y={397.83}
        width={9.88}
        height={60.6}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "337.03px 428.13px 0px",
        }}
        id="elga7dgpa2uo"
        className="animable"
      />
      <g id="elchvdqm0ot3l">
        <rect
          x={370.06}
          y={344.84}
          width={9.88}
          height={96.1}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "375px 392.89px 0px",
            transform: "rotate(90deg)",
          }}
          className="animable"
        />
      </g>
      <rect
        x={406.58}
        y={397.83}
        width={9.88}
        height={60.6}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "411.52px 428.13px 0px",
        }}
        id="elxho2hhrcav8"
        className="animable"
      />
      <polygon
        points="332.09 397.83 332.09 399.52 416.47 400.13 416.47 397.83 332.09 397.83"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "374.28px 398.98px 0px",
        }}
        id="elcbkhd2dpert"
        className="animable"
      />
      <g id="elbqy0j8o8a1">
        <g
          style={{
            opacity: 0.2,
            transformOrigin: "374.275px 430.125px 0px",
          }}
          className="animable"
        >
          <polygon
            points="361.14 401.82 341.97 420.99 341.97 409.63 349.78 401.82 361.14 401.82"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "351.555px 411.405px 0px",
            }}
            id="el61ia1rspsv7"
            className="animable"
          />
          <polygon
            points="372.62 435.76 372.62 441.44 355.63 458.43 349.95 458.43 372.62 435.76"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "361.285px 447.095px 0px",
            }}
            id="eldfe44do6bfa"
            className="animable"
          />
          <polygon
            points="406.58 401.82 406.58 407.48 375.94 438.12 375.94 432.44 406.56 401.82 406.58 401.82"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "391.26px 419.97px 0px",
            }}
            id="elvxfwb4chkg"
            className="animable"
          />
        </g>
      </g>
      <g id="elb42tk3gqag">
        <g
          style={{
            opacity: 0.2,
            transformOrigin: "375px 257.27px 0px",
          }}
          className="animable"
        >
          <polygon
            points="322.32 267.61 333.69 267.61 309.24 292.06 309.24 280.69 322.32 267.61"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "321.465px 279.835px 0px",
            }}
            id="el3z35bfxon7u"
            className="animable"
          />
          <polygon
            points="344.54 245.39 370.16 219.77 370.16 231.14 354.36 246.94 344.54 246.94 344.54 245.39"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "357.35px 233.355px 0px",
            }}
            id="eljpd6jdbmskb"
            className="animable"
          />
          <polygon
            points="380.49 209.44 391.86 209.44 379.84 221.46 379.84 210.09 380.49 209.44"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "385.85px 215.45px 0px",
            }}
            id="el91oraht488"
            className="animable"
          />
          <polygon
            points="405.46 184.47 405.46 188.77 401.16 188.77 405.46 184.47"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "403.31px 186.62px 0px",
            }}
            id="elim1h2dw676"
            className="animable"
          />
          <polygon
            points="388.32 363.28 405.46 346.14 405.46 357.5 399.68 363.28 388.32 363.28"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "396.89px 354.71px 0px",
            }}
            id="el4s3fjew1eva"
            className="animable"
          />
          <polygon
            points="437.19 325.77 415.14 347.82 415.14 336.46 425.83 325.77 437.19 325.77"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "426.165px 336.795px 0px",
            }}
            id="elvk6gaqt1p47"
            className="animable"
          />
          <polygon
            points="379.84 361.27 405.46 335.65 405.46 336.95 379.84 362.57 379.84 361.27"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "392.65px 349.11px 0px",
            }}
            id="elk9m4lobvic"
            className="animable"
          />
          <polygon
            points="416.64 325.77 415.14 327.27 415.14 325.97 415.34 325.77 416.64 325.77"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "415.89px 326.52px 0px",
            }}
            id="el86w1lm7wurc"
            className="animable"
          />
          <polygon
            points="440.76 300.35 440.76 301.65 437.29 305.12 435.99 305.12 440.76 300.35"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "438.375px 302.735px 0px",
            }}
            id="el4yv1tffcux"
            className="animable"
          />
          <polygon
            points="309.24 301.8 334.86 276.18 334.86 277.48 309.24 303.1 309.24 301.8"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "322.05px 289.64px 0px",
            }}
            id="el66rejea5c5k"
            className="animable"
          />
          <polygon
            points="344.54 267.61 344.73 267.61 344.54 267.8 344.54 267.61"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "344.635px 267.705px 0px",
            }}
            id="elbfz4th5nx1t"
            className="animable"
          />
          <polygon
            points="364.1 246.94 370.16 240.88 370.16 242.18 365.4 246.94 364.1 246.94"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "367.13px 243.91px 0px",
            }}
            id="elnrb9r7yb27i"
            className="animable"
          />
          <polygon
            points="401.6 209.44 402.9 209.44 379.84 232.5 379.84 231.2 401.6 209.44"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "391.37px 220.97px 0px",
            }}
            id="elf5u9u4khnc6"
            className="animable"
          />
          <polygon
            points="440.76 170.28 440.76 171.58 423.57 188.77 422.27 188.77 440.76 170.28"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "431.515px 179.525px 0px",
            }}
            id="elawqtyhq6hhf"
            className="animable"
          />
          <polygon
            points="309.24 236.13 334.86 210.51 334.86 211.81 309.24 237.43 309.24 236.13"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "322.05px 223.97px 0px",
            }}
            id="elne6fy2blfc"
            className="animable"
          />
          <polygon
            points="356.6 188.77 370.16 175.21 370.16 176.51 357.9 188.77 356.6 188.77"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "363.38px 181.99px 0px",
            }}
            id="elpg9aaxe02fm"
            className="animable"
          />
          <polygon
            points="395.41 151.26 379.84 166.83 379.84 165.53 394.11 151.26 395.41 151.26"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "387.625px 159.045px 0px",
            }}
            id="elzh8ywo513yi"
            className="animable"
          />
          <polygon
            points="334.86 158.11 334.86 163.81 309.9 188.77 309.24 188.77 309.24 183.73 334.86 158.11"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "322.05px 173.44px 0px",
            }}
            id="elc0t4wo1qwim"
            className="animable"
          />
          <polygon
            points="309.24 351.47 334.86 325.85 334.86 331.55 309.24 357.17 309.24 351.47"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "322.05px 341.51px 0px",
            }}
            id="elo55swwg4qmf"
            className="animable"
          />
          <polygon
            points="393.1 267.61 398.8 267.61 379.84 286.57 370.16 296.25 361.29 305.12 355.59 305.12 370.16 290.55 379.84 280.87 393.1 267.61"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "377.195px 286.365px 0px",
            }}
            id="eloala5qx2x5"
            className="animable"
          />
          <polygon
            points="440.76 219.96 440.76 225.65 419.47 246.94 415.14 246.94 415.14 245.58 440.76 219.96"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "427.95px 233.45px 0px",
            }}
            id="el7sg05z6pl8u"
            className="animable"
          />
          <polygon
            points="309.6 305.12 334.86 279.86 334.86 285.55 315.29 305.12 309.6 305.12"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "322.23px 292.49px 0px",
            }}
            id="el95qukcyslw"
            className="animable"
          />
          <polygon
            points="347.11 267.61 352.8 267.61 344.54 275.87 344.54 270.18 347.11 267.61"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "348.67px 271.74px 0px",
            }}
            id="eldo1azcqa68v"
            className="animable"
          />
          <polygon
            points="367.78 246.94 370.16 244.56 370.16 246.94 367.78 246.94"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "368.97px 245.75px 0px",
            }}
            id="el1yj6nnmnkva"
            className="animable"
          />
          <polygon
            points="405.28 209.44 405.46 209.44 405.46 214.95 379.84 240.57 379.84 234.88 405.28 209.44"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "392.65px 225.005px 0px",
            }}
            id="elwi7tmkk46f"
            className="animable"
          />
          <polygon
            points="440.76 173.96 440.76 179.65 431.64 188.77 425.95 188.77 440.76 173.96"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "433.355px 181.365px 0px",
            }}
            id="el4l76jtifsj"
            className="animable"
          />
          <polygon
            points="326.59 325.77 327.89 325.77 309.24 344.42 309.24 343.12 326.59 325.77"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "318.565px 335.095px 0px",
            }}
            id="elrnlml7fw1x"
            className="animable"
          />
          <polygon
            points="384.75 267.61 386.05 267.61 379.84 273.82 370.16 283.5 348.54 305.12 347.24 305.12 384.75 267.61"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "366.645px 286.365px 0px",
            }}
            id="els5wnifvax0s"
            className="animable"
          />
          <polygon
            points="405.42 246.94 405.46 246.9 405.46 246.94 405.42 246.94"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "405.44px 246.92px 0px",
            }}
            id="el43b4l5cav8f"
            className="animable"
          />
          <polygon
            points="440.76 211.6 440.76 212.9 415.14 238.52 415.14 237.22 440.76 211.6"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "427.95px 225.06px 0px",
            }}
            id="elm27gr1fcd7m"
            className="animable"
          />
        </g>
      </g>
      <circle
        cx={375}
        cy={80.72}
        r={19.06}
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "375px 80.72px 0px",
        }}
        id="eltfvpivt87re"
        className="animable"
      />
      <rect
        x={371.9}
        y={68.79}
        width={6.2}
        height={23.85}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "375px 80.715px 0px",
        }}
        id="elwerv4rnsuz"
        className="animable"
      />
      <g id="elp7yw7ii8c8g">
        <rect
          x={371.9}
          y={68.79}
          width={6.2}
          height={23.85}
          style={{
            fill: "rgb(255, 255, 255)",
            transformOrigin: "375px 80.715px 0px",
            transform: "rotate(-90deg)",
          }}
          className="animable"
        />
      </g>
    </g>
    <g
      id="freepik--Floor--inject-47"
      style={{
        transformOrigin: "375px 458.43px 0px",
      }}
      className="animable"
    >
      <path
        d="M60.7,458.43c201.36-.61,427.24-.62,628.6,0-201.36.62-427.24.61-628.6,0Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "375px 458.43px 0px",
        }}
        id="eloi0swr36ws"
        className="animable"
      />
    </g>
    <g
      id="freepik--Ambulance--inject-47"
      style={{
        transformOrigin: "267.02px 427.844px 0px",
      }}
      className="animable"
    >
      <path
        d="M251.52,408.25H245.9l.47-2.34.39-1.87a.69.69,0,0,1,.68-.56h2.75a.69.69,0,0,1,.68.59l0,.19Z"
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "248.71px 405.865px 0px",
        }}
        id="elzdqvwmbyy3"
        className="animable"
      />
      <polygon
        points="252.26 409.25 244.83 410.5 245.33 408.24 245.38 408 252.02 408 252.15 408.71 252.26 409.25"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "248.545px 409.25px 0px",
        }}
        id="elz1yyb40xpa"
        className="animable"
      />
      <path
        d="M255.36,408.49l-1.09,24.17-.22,4.8L253.53,449H220.37l2.38-11.35.74-3.55a2.24,2.24,0,0,1,.2-.53,2,2,0,0,1,.54-.66,2.13,2.13,0,0,1,.61-.34l10-3.48a2.08,2.08,0,0,0,1.25-1.23l6-16.1a2.06,2.06,0,0,1,1.6-1.32Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "237.865px 428.745px 0px",
        }}
        id="elnvpcl3owv4"
        className="animable"
      />
      <polygon
        points="251.12 413.27 251.03 414.88 251.01 415.26 250.7 420.76 250.52 423.88 250.45 425.03 250.43 425.41 250.34 426.94 248.75 427.09 248.35 427.13 247.16 427.24 243.91 427.54 239.14 427.99 239.58 426.69 239.76 426.14 241.64 420.62 242.4 418.39 243.97 413.77 247.25 413.54 248.83 413.43 251.12 413.27"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "245.13px 420.63px 0px",
        }}
        id="elxbvfq6cp38r"
        className="animable"
      />
      <g id="elpngy4iu1o37">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "245.305px 420.485px 0px",
          }}
          className="animable"
        >
          <polygon
            points="250.7 420.76 250.52 423.88 247.16 427.24 243.91 427.54 250.7 420.76"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "247.305px 424.15px 0px",
            }}
            id="eln8kk966mlwe"
            className="animable"
          />
          <polygon
            points="248.83 413.43 241.64 420.62 242.4 418.39 247.25 413.54 248.83 413.43"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "245.235px 417.025px 0px",
            }}
            id="el46o9ci2pdmc"
            className="animable"
          />
          <polygon
            points="251.03 414.88 251.01 415.26 239.58 426.69 239.76 426.14 251.03 414.88"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "245.305px 420.785px 0px",
            }}
            id="elj17fj2rn0l"
            className="animable"
          />
          <polygon
            points="250.45 425.03 250.43 425.41 248.75 427.09 248.35 427.13 250.45 425.03"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "249.4px 426.08px 0px",
            }}
            id="elyzpw17l5rlj"
            className="animable"
          />
        </g>
      </g>
      <polygon
        points="239.14 427.99 243.97 413.77 251.12 413.27 251.12 413.27 244.42 414.55 239.14 427.99"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "245.13px 420.63px 0px",
        }}
        id="el7hob6gpexyr"
        className="animable"
      />
      <rect
        x={235.24}
        y={429.4}
        width={0.23}
        height={18.93}
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "235.355px 438.865px 0px",
        }}
        id="el56dnfy1peia"
        className="animable"
      />
      <path
        d="M254.17,432.67l-.23,4.79-31.19.14.74-3.55a2.24,2.24,0,0,1,.2-.53Z"
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "238.46px 435.135px 0px",
        }}
        id="elzy3jqo7wrgs"
        className="animable"
      />
      <path
        d="M222.34,432.88l2.69-.42L223.46,438l-1.39-.15a.57.57,0,0,1-.51-.61l.3-3.84A.57.57,0,0,1,222.34,432.88Z"
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "223.294px 435.23px 0px",
        }}
        id="eltgf325d4ovo"
        className="animable"
      />
      <path
        d="M237.42,424.54c.65.55.06,5.51-.4,5.42a5.27,5.27,0,0,1-1.84-.58c-.4-.32-2.64-4.33-2.09-5.16S236.92,424.12,237.42,424.54Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "235.356px 426.901px 0px",
        }}
        id="elavx2ceow7wb"
        className="animable"
      />
      <path
        d="M309.4,407.41l-50.73-1.83,1.66-3.44h0l1-2.09a3.37,3.37,0,0,1,3-1.91l39.53-.89a3.37,3.37,0,0,1,3.32,2.41l.31,1.06h0Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "284.035px 402.329px 0px",
        }}
        id="elipxxhjh4di8"
        className="animable"
      />
      <polygon
        points="262.05 402.86 262.56 401.55 266.31 401.52 266.2 403.02 262.05 402.86"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "264.18px 402.27px 0px",
        }}
        id="elvr69jpkcgkb"
        className="animable"
      />
      <polygon
        points="302.08 403.48 302.18 401.66 306.67 401.99 306.7 403.45 302.08 403.48"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "304.39px 402.57px 0px",
        }}
        id="el23izsjnevm"
        className="animable"
      />
      <path
        d="M314.77,449H253.4l.54-11.49.23-4.79,1.19-25.24,0-.46a2.81,2.81,0,0,1,3-2.67L309,405.74a2.83,2.83,0,0,1,2.64,2.6l1.75,23,.45,5.85Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "284.085px 426.672px 0px",
        }}
        id="elutpp50saaz9"
        className="animable"
      />
      <polygon
        points="281.51 414.09 281.49 414.73 281.38 417.99 281.37 418.36 281.31 420.28 281.21 423.32 281.1 426.62 277.87 426.66 274.89 426.7 273.02 426.72 272.65 426.72 269.46 426.76 267.98 426.78 261.39 426.86 261.02 426.86 259 426.89 258.36 426.89 258.47 424.48 258.61 421.05 258.63 420.68 258.7 418.97 258.77 417.44 258.96 413.04 262.98 413.23 264.38 413.29 265.94 413.37 266.28 413.38 269.42 413.53 272.23 413.66 274.13 413.75 274.48 413.76 280.7 414.06 281.51 414.09"
        style={{
          fill: "rgb(55, 71, 79)",
          transformOrigin: "269.935px 419.965px 0px",
        }}
        id="eln2gk2hkf9z"
        className="animable"
      />
      <g id="elv1bim4qg0i">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "269.935px 420.06px 0px",
          }}
          className="animable"
        >
          <polygon
            points="272.23 413.66 259 426.89 258.36 426.89 258.47 424.48 269.42 413.53 272.23 413.66"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "265.295px 420.21px 0px",
            }}
            id="el0ynru5u9fx8f"
            className="animable"
          />
          <polygon
            points="281.31 420.28 281.21 423.32 277.87 426.66 274.89 426.7 281.31 420.28"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "278.1px 423.49px 0px",
            }}
            id="el6ngo954unxc"
            className="animable"
          />
          <polygon
            points="281.51 414.09 281.49 414.73 269.46 426.76 267.98 426.78 280.7 414.06 281.51 414.09"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "274.745px 420.42px 0px",
            }}
            id="el140ioks0j8y"
            className="animable"
          />
          <polygon
            points="264.38 413.29 258.7 418.97 258.77 417.44 262.98 413.23 264.38 413.29"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "261.54px 416.1px 0px",
            }}
            id="elptck5t2nx8e"
            className="animable"
          />
          <polygon
            points="266.28 413.38 258.61 421.05 258.63 420.68 265.94 413.37 266.28 413.38"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "262.445px 417.21px 0px",
            }}
            id="elndl7a8tn2ne"
            className="animable"
          />
          <polygon
            points="274.48 413.76 261.39 426.86 261.02 426.86 274.13 413.75 274.48 413.76"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "267.75px 420.305px 0px",
            }}
            id="elgrtx0xoyht"
            className="animable"
          />
          <polygon
            points="281.38 417.99 281.37 418.36 273.02 426.72 272.65 426.72 281.38 417.99"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "277.015px 422.355px 0px",
            }}
            id="el9sg3s7vhsxf"
            className="animable"
          />
        </g>
      </g>
      <polygon
        points="258.36 426.89 258.96 413.04 281.51 414.09 260.19 414.23 258.36 426.89"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "269.935px 419.965px 0px",
        }}
        id="elv16u5xy408g"
        className="animable"
      />
      <polygon
        points="313.88 437.2 313.88 437.2 254.05 437.46 253.94 437.46 254.16 432.67 254.27 432.66 313.43 431.36 313.88 437.2"
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "283.91px 434.41px 0px",
        }}
        id="ellg6t3kjkubg"
        className="animable"
      />
      <polygon
        points="299.94 424.89 297.27 424.89 297 415.05 299.94 415.05 299.94 424.89"
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "298.47px 419.97px 0px",
        }}
        id="elx8d5g1xqmn8"
        className="animable"
      />
      <polygon
        points="303.49 418.51 303.57 421.44 293.72 421.43 293.65 418.77 303.49 418.51"
        style={{
          fill: "rgb(153, 113, 225)",
          transformOrigin: "298.61px 419.975px 0px",
        }}
        id="elh4sa58pb9pn"
        className="animable"
      />
      <polygon
        points="314.77 451.13 218.84 451.13 218.84 448.04 218.84 448.04 314.77 448.04 314.77 451.13"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "266.805px 449.585px 0px",
        }}
        id="el3l1rxmbd1vn"
        className="animable"
      />
      <polygon
        points="216.67 446.55 227.06 447.19 227.06 451.61 215.9 451.61 216.67 446.55"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "221.48px 449.08px 0px",
        }}
        id="elh7ni0bh4u9"
        className="animable"
      />
      <path
        d="M316.49,446.6l-4.42.53a1,1,0,0,0-.93,1v3.48h7l-.64-4.16A1,1,0,0,0,316.49,446.6Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "314.64px 449.105px 0px",
        }}
        id="elunfvhkb2pzm"
        className="animable"
      />
      <path
        d="M303.31,451.75a1.16,1.16,0,0,1-1.14-1c0-.22-.89-5.4-6.11-5.4s-6,5.17-6,5.39a1.15,1.15,0,0,1-2.27-.31,8.33,8.33,0,0,1,8.3-7.37,8.44,8.44,0,0,1,8.38,7.36,1.15,1.15,0,0,1-1,1.3Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "296.135px 447.405px 0px",
        }}
        id="elenizwcbcg0v"
        className="animable"
      />
      <path
        d="M296.1,444.44c9,0,9,14,0,14S287.06,444.44,296.1,444.44Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "296.093px 451.44px 0px",
        }}
        id="elu049yohog5"
        className="animable"
      />
      <path
        d="M296.1,448.26c4.1,0,4.1,6.37,0,6.37S292,448.26,296.1,448.26Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "296.1px 451.445px 0px",
        }}
        id="elefx8q5bxwcf"
        className="animable"
      />
      <path
        d="M245.1,451.75a1.14,1.14,0,0,1-1.13-1c0-.22-.89-5.4-6.11-5.4s-6,5.17-6,5.39a1.14,1.14,0,0,1-1.29,1,1.16,1.16,0,0,1-1-1.29c.35-2.55,2.53-7.37,8.31-7.37s8,4.81,8.37,7.36a1.14,1.14,0,0,1-1,1.3Z"
        style={{
          fill: "rgb(219, 219, 219)",
          transformOrigin: "237.912px 447.415px 0px",
        }}
        id="el6zbm6mxnmkn"
        className="animable"
      />
      <path
        d="M237.86,444.44c9,0,9,14,0,14S228.82,444.44,237.86,444.44Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "237.853px 451.44px 0px",
        }}
        id="elzn8grz7ak1n"
        className="animable"
      />
      <path
        d="M237.86,448.26c4.1,0,4.1,6.37,0,6.37S233.76,448.26,237.86,448.26Z"
        style={{
          fill: "rgb(235, 235, 235)",
          transformOrigin: "237.86px 451.445px 0px",
        }}
        id="elp9g97mspw2q"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
)
export default OrganizationsAnimated
